import axios from 'axios';

const axios_instance = axios.create({
  baseURL: import.meta.env.VITE_SERVER_URL,
});

axios_instance.defaults.withCredentials = true;

export default axios_instance;
